$(function () {
	if ($('.mainSlide').length) {
		$('.mainSlide').slick({
			fade: true,
			arrows: false,
			autoplay: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			speed: 1000,
		}).on('touchend', function () {
			$('.mainSlide').slick('slickPlay');
		})
	}
	if ($('#gHeader').length) {
		$(window).on('scroll', function () {
			let scrollTop = $(this).scrollTop();
			if (scrollTop > 100 || $('#gHeader .menu').hasClass('open')) {
				$('#gHeader').addClass('hasBg');
			} else {
				$('#gHeader').removeClass('hasBg');
			};
		}).trigger('scroll');

		var state = false;
		var scrollpos;

		$('#gHeader .menu').on('click', function () {
			if (state == false) {
				scrollpos = $(window).scrollTop();
				$('body').addClass('fixed').css({ 'top': -scrollpos });
				$(this).addClass('open');
				$('.menuBox').stop().fadeIn();
				$('#gHeader .iconBox .cartBtn').fadeOut();
				state = true;
			} else {
				$('body').removeClass('fixed').css({ 'top': 0 });
				window.scrollTo(0, scrollpos);
				$(this).removeClass('open');
				$('.menuBox').stop().fadeOut();
				$('#gHeader .iconBox .cartBtn').fadeIn();
				state = false;
			}
			return false;
		});
	}
	if ($('.top-lineup .slideBox').length) {
		$('.top-lineup .slideBox').slick({
			centerMode: true,
			centerPadding: '18px',
			variableWidth: true,
			speed: 1000
		});
	}
	if ($('#gFooter .pageTop').length) {
		$('#gFooter .pageTop a').on('click', function () {
			$('html,body').animate({ scrollTop: 0 }, 1000);
			return false;
		});
	}
	if (!$('.mainSlide,.nopadding').length && $('#MainContent').length) {
		$('#MainContent').css('padding-top', $('#gHeader').outerHeight());
	}
	if ($('#MainContent .pageDetail .product__media-wrapper .bigList').length) {
		$('#MainContent .pageDetail .product__media-wrapper .bigList').slick({
			fade: true,
			arrows: false,
		});
		$('#MainContent .pageDetail .product__media-wrapper .smallList > li').eq(0).addClass('active');
		$('#MainContent .pageDetail .product__media-wrapper .bigList').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$('#MainContent .pageDetail .product__media-wrapper .smallList > li').removeClass('active').eq(nextSlide).addClass('active');
		});
		$('#MainContent .pageDetail .product__media-wrapper .smallList > li').on('click', function () {
			let ind = $(this).index();
			$('#MainContent .pageDetail .product__media-wrapper .bigList').slick('slickGoTo', ind);
		})
	}
	if ($('#MainContent .pageDetail .product__info-wrapper .price .price-item').length) {
		var $priceElement = $('#MainContent .pageDetail .product__info-wrapper .price .price-item');
		var originalText = $priceElement.html();
		var replacedText = originalText.replace(/¥(\d{1,3}(,\d{3})*|\d+) JPY/g, function (match, p1) {
			return p1 + '円' + '<span class="isTax">(税込)</span>';
		});
		$priceElement.html(replacedText);
	}
	if ($('#MainContent .pageDetail .product__info-wrapper .slideBox').length) {
		$('#MainContent .pageDetail .product__info-wrapper .slideBox .slideTtl').on('click', function () {
			$(this).toggleClass('active');
			$(this).next('.slideInner').stop().slideToggle();
		})
	}
    if($('.scrollLink').length){
		$('.scrollLink').on('click', function () {
			var $target = $(this.hash);
			if ($target.length) {
				var targetOffset = $target.offset().top - $('#gHeader').outerHeight();
				$('html,body').animate({scrollTop: targetOffset}, 1000);
				return false;
			}
		});
	}

  	if($('.fadeIn').length){
		$(window).on('scroll',function(){
			let scrolltop = $(this).scrollTop();
			$('.fadeIn').each(function(){
				let top = $(this).offset().top - window.innerHeight;
				let $this = $(this);
				if(scrolltop > top){
					setTimeout(function(){
						$this.addClass('active');
					}, 500);
				}
			})
		}).trigger('scroll');
	}

  if($('.top-concept .slideimg').length){
    $('.top-concept .slideimg .img').infiniteslide({
      'speed': 100,
      'direction': 'left',
      'pauseonhover': false,
      'clone': 3
    })
  }
  if(!$('.customPage').length && $('#gFooter').length){
    $('#gFooter').css('margin-top','80px');
  }
});

document.addEventListener("DOMContentLoaded", function () {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if (cart.item_count > 0) {
                $('.cart-notification').show();
            } else {
                $('.cart-notification').hide();
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
});